// extracted by mini-css-extract-plugin
export default {"overlay":"PA-z","bodyOpen":"QA-z","content":"RA-z","header":"SA-z","closeNoHeading":"TA-z"};